import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { withVars, toLength } from "./styleVars.js";
const AppTile = React.forwardRef(function AppTile2({ app, glyph, size, label, className, style, ...rest }, ref) {
  const named = label != null && label !== "";
  return /* @__PURE__ */ jsx(
    "span",
    {
      ref,
      className: cx("ev-app-tile", className),
      "data-app": app || void 0,
      role: named ? "img" : void 0,
      "aria-label": named ? label : void 0,
      "aria-hidden": named ? void 0 : true,
      style: withVars(style, { "--ev-app-tile-size": size != null ? toLength(size) : void 0 }),
      ...rest,
      children: glyph
    }
  );
});
export {
  AppTile
};
//# sourceMappingURL=AppTile.js.map
